<!-- Vue SFC -->
<template>
  <div class="nestable-tree">
    <treeselect :value="value"
                :options="options"
                :normalizer="normalizer"
                :placeholder="placeholder"
                :no-options-text="noOptionsText"
                :noResultsText="noResultsText"
                :always-open="alwaysOpen"
                :flat="flat"
                :sort-value-by="sortValueBy"
                multiple
                @select="emitSelect"
                @deselect="emitDeselect"
                @input="emitInput">
      <div class="nestable-tree-value"
           slot="value-label"
           slot-scope="{ node }">{{ node.label  }}</div>

      <div class="nestable-tree-option"
           slot="option-label"
           slot-scope="{ node }">
        <slot name="option-label"
              v-bind:node="node" />
      </div>
    </treeselect>
  </div>
</template>

<script>
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  // register the component
  components: { Treeselect },

  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    normalizer: {
      type: Function,
    },
    value: {
      type: Array,
    },
    placeholder: {
      type: String,
    },
    noOptionsText: {
      type: String,
    },
    noResultsText: {
      type: String,
    },
    alwaysOpen: {
        type: Boolean
    },
    flat: {
      type: Boolean,
      default: false
    },
    sortValueBy: {
      type: String
    }
  },

  data() {
    return {
      multiple: true,
    };
  },

  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },
    emitSelect(val) {
      this.$emit("select", val);
    },
    emitDeselect(val) {
        this.$emit("deselect", val);
    }
  },
};
</script>

<style lang="scss" scoped>
.nestable-tree {
  .nestable-tree-option {
    font-size: 12px;
  }
}
</style>
